import React, { useEffect, useState } from 'react';
import supabase from '../supabase';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
import MDBoxRoot from './MDBox/MDBoxRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDInput from './MDInput/MDInputRoot';



const Login: React.FC = () => {
  const navigate = useNavigate();///********** */
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const validateEmail = (email: string): boolean => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };


  const handleSignIn = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.signInWithPassword({ email, password });
    
    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess('Successfully signed in!');
      navigate('/dashboard', { replace: true });
    }
  };

  const handleSignUp = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.signUp({ email, password, options: { data: { admin_signup: 'true' } } });

    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess('Sign-up successful! Please check your email to confirm your account.');
    }
  };

  const handleResetPassword = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    const { error } = await supabase.auth.resetPasswordForEmail(email, {redirectTo: `${window.location.origin}/reset_password` });

    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess('Password reset link sent! Please check your email.');
    }
  };

  return (
    <MDBoxRoot sx={{ maxWidth: 1600, align:"center", display: 'flex', justifyContent:'center', mt:6}}>
    <Card sx={{padding:"4px 32px 20px"}}>
    <MDBoxRoot sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <MDTypographyRoot ownerState={{color:"dark", marginBottom:4}} textAlign="center" variant="h2">
        Sign In or Sign Up
      </MDTypographyRoot> 
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <MDInput
        label="Email"
        type="email"
        variant="outlined"
        fullWidth
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={loading}
        sx={{ mb: 2, padding:0 }}
      />
      <MDInput
        label="Password"
        type="password"
        variant="outlined"
        fullWidth
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        disabled={loading}
        sx={{ mb: 2, padding:0 }}
      />
      <MDButtonRoot
        ownerState={{
          size: "medium",
          color: "primary",
          variant:"contained",
          textTransform:"uppercase",
      }}
        fullWidth
        onClick={handleSignIn}
        disabled={loading || !email || !password}
        sx={{ mb: 2 }}
      >
        {loading ? 'Signing in...' : 'Sign In'}
      </MDButtonRoot>
      <MDButtonRoot
              ownerState={{
                size: "medium",
                color: "secondary",
                variant:"contained",
                textTransform:"uppercase",
              }}
        fullWidth
        onClick={handleSignUp}
        disabled={loading || !email || !password}
        sx={{ mb: 2 }}
      >
        {loading ? 'Signing up...' : 'Sign Up'}
      </MDButtonRoot>
      <MDButtonRoot
      ownerState={{
        size: "medium",
        color: "primary",
        variant:"text",
        textTransform:"uppercase",
    }}
        fullWidth
        onClick={handleResetPassword}
        disabled={loading || !email}
      >
        {loading ? 'Sending reset link...' : 'Forgot Password?'}
      </MDButtonRoot>            
    </MDBoxRoot>
    </Card>
    </MDBoxRoot>
  );
};

export default Login;
